import { Component } from '@angular/core';

@Component({
	selector: 'app-gdpa',
	templateUrl: './app.gdpa.component.html',
})
export class GdpaComponent {

}
